import { motion } from "framer-motion";
import { MENTORS, MENTORS_SECTION } from "../data/home-data";

export default function Mentors() {
    const row1 = MENTORS.filter((_, i) => i % 2 === 0);
    const row2 = MENTORS.filter((_, i) => i % 2 === 1);

    return (
        <section className="pt-4 pb-10 bg-white" data-testid="mentors-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-8">
                <div className="text-center max-w-2xl mx-auto mb-14">
                    <p className="text-xs uppercase tracking-[0.3em] text-aiorange font-bold mb-3">
                        {MENTORS_SECTION.tag}
                    </p>
                    <h2
                        className="font-display font-black text-4xl sm:text-5xl tracking-normal leading-tight"
                        dangerouslySetInnerHTML={{
                            __html: MENTORS_SECTION.headline,
                        }}
                    />
                    <p className="mt-4 text-gray-600">
                        {MENTORS_SECTION.description}
                    </p>
                </div>

                {/* Marquee rows with white-mist fades on both edges */}
                <div className="relative">
                    <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-28 bg-gradient-to-r from-white to-transparent z-10" />
                    <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-28 bg-gradient-to-l from-white to-transparent z-10" />

                {/* Row 1 - Moving right → left */}
                <div className="overflow-hidden mb-6">
                    <div className="flex gap-6 hp-marquee">
                        {[...row1, ...row1].map((m, i) => (
                            <motion.div
                                key={`row1-${i}`}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: i * 0.05 }}
                                className="bg-white border border-gray-100 rounded-3xl p-6 hover:shadow-2xl hover:shadow-aiblue/10 transition group flex-shrink-0 w-[320px] relative"
                                data-testid={`mentor-card-${i}`}
                            >
                                <div className="relative w-fit">
                                    <img
                                        src={m.img}
                                        alt={m.name}
                                        className="h-20 w-20 rounded-full object-cover ring-4 ring-aipeach/40"
                                    />
                                </div>
                                <div className="absolute top-4 right-4 z-10 bg-white/90 backdrop-blur rounded-lg p-1 shadow-sm border border-gray-100">
                                    <img
                                        src={m.logo}
                                        alt={m.company}
                                        className="h-7 w-auto max-w-[72px] object-contain"
                                    />
                                </div>
                                <h3 className="font-display font-bold text-lg mt-4">
                                    {m.name}
                                </h3>
                                <p className="text-sm text-gray-600">
                                    {m.role}
                                </p>
                                <p className="text-xs uppercase tracking-widest text-aiorange font-bold mt-3">
                                    {m.domain}
                                </p>
                                {/* <div className="mt-4 pt-4 border-t border-gray-100 text-xs text-gray-500">
                                    {MENTORS_SECTION.cardFooter}
                                </div> */}
                            </motion.div>
                        ))}
                    </div>
                </div>

                {/* Row 2 - Moving left → right (opposite of row 1) */}
                <div className="overflow-hidden">
                    <div className="flex gap-6 hp-marquee hp-marquee-reverse">
                        {[...row2, ...row2].map((m, i) => (
                            <motion.div
                                key={`row2-${i}`}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: i * 0.05 }}
                                className="bg-white border border-gray-100 rounded-3xl p-6 hover:shadow-2xl hover:shadow-aiblue/10 transition group flex-shrink-0 w-[320px] relative"
                                data-testid={`mentor-card-row2-${i}`}
                            >
                                <div className="relative w-fit">
                                    <img
                                        src={m.img}
                                        alt={m.name}
                                        className="h-20 w-20 rounded-full object-cover ring-4 ring-aimint/40"
                                    />
                                </div>
                                <div className="absolute top-4 right-4 z-10 bg-white/90 backdrop-blur rounded-lg p-1 shadow-sm border border-gray-100">
                                    <img
                                        src={m.logo}
                                        alt={m.company}
                                        className="h-7 w-auto max-w-[72px] object-contain"
                                    />
                                </div>
                                <h3 className="font-display font-bold text-lg mt-4">
                                    {m.name}
                                </h3>
                                <p className="text-sm text-gray-600">
                                    {m.role}
                                </p>
                                <p className="text-xs uppercase tracking-widest text-aiblue font-bold mt-3">
                                    {m.domain}
                                </p>
                                {/* <div className="mt-4 pt-4 border-t border-gray-100 text-xs text-gray-500">
                                    {MENTORS_SECTION.cardFooter}
                                </div> */}
                            </motion.div>
                        ))}
                    </div>
                </div>
                </div>
            </div>
        </section>
    );
}
